import { FC } from "react";
import { useTranslation } from "react-i18next";
import ImageWithEmptyFallback from "@Components/ImageWithEmptyFallback/ImageWithEmptyFallback";
import { RedemptionChannelTag } from "src/components";
import GiftcardHtml from "../GiftcardHtml/GiftcardHtml";
import { GiftcardItem } from "src/store/slices/item/subitems/giftcards.types";

type Props = {
  data: GiftcardItem | undefined;
  imageUrl: string | undefined;
  brandName?: string;
};

const GiftcardDetailsCardNew: FC<Props> = ({ data, imageUrl, brandName }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-start justify-between gap-3 md:gap-4">
        <div className="flex items-center gap-2 md:gap-4 flex-1">
          <ImageWithEmptyFallback
            src={imageUrl}
            alt={brandName}
            className="size-20! max-w-20! md:size-28! md:max-w-28! shrink-0 object-cover p-2 aspect-square rounded-sm outline outline-border-subtle"
          />
          <div className="flex flex-col gap-1">
            <span className="text-base font-bold text-font-default md:text-2xl">{brandName}</span>
          </div>
        </div>
        {data?.redemptionChannel && (
          <RedemptionChannelTag
            channel={data.redemptionChannel}
            label={t(`Giftcards.redemptionChannels.${data.redemptionChannel}`, data.redemptionChannel)}
          />
        )}
      </div>
      {data?.description && <GiftcardHtml html={data.description} className="text-sm text-font-subtle flex flex-col gap-2" />}
    </div>
  );
};

export default GiftcardDetailsCardNew;
